export class ProgramCategoryEdit
{
    public id = null;
    public name = '';
    public active = true;
}
